
import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import classNames from "classnames";
// import Coin_exchange from "./coin_exchange";
// import Ai from "./coin_option";
import Orders_home from "./orders/orders_home.jsx";
import Orders from "../../order/orders/orders.jsx";
import History_home from "./history/home.jsx";
import Options from "./options.jsx";
import Api_docs from "../../order/orders/api_docs.jsx";
// import Coin_seller_home from "./coin_seller_home";
// import Coin_partner_home from "./coin_partner_home";
import Post_content from '../../community/content/Blog_posts.jsx';
import ProfileNav_orders from '../../order/orders/ProfileNav.jsx';
import ProfileNav from '../../app_structure/tabs_nav/ProfileNav.jsx';

const Coin_home = () => {
    const { slug_1, slug_2, slug_3, slug_4 } = useParams();
    const [userOption, setUserOption] = useState(slug_2);
    const navigate = useNavigate();
    return (
        <>
            {(slug_1 != "orders_once" && slug_2 != "home_ai" && slug_2 != "home_notes") && (
                <>
                    <div className="mt-1 flex justify-center mt-0 gap-2">
                        {((slug_1 == "utility" || slug_1 == "plans" || slug_1 == "history") && slug_2 != 'api_docs') && (
                            <ProfileNav_orders userOption={userOption} setUserOption={setUserOption} />
                        )}
                    </div>
                    <div className="text-center mt-2">
                        <div className="inline-block border-2 border-green-100 text-center font-medium bg-white/5 backdrop-blur-lg py-1 px-2 rounded-xl shadow-md">
                            <ProfileNav category={'ai_utility'} slug_1={slug_1} slug_2={slug_2} slug_3={slug_3} slug_4={slug_4} />
                        </div>
                    </div>
                </>)}

            {(slug_1 == "home") && (
                <Options />
            )}
            {((slug_1 == "utility" || slug_1 == "plans" || slug_1 == "orders_once") && slug_2 != 'api_docs') && (
                <>
                    <Orders_home />
                </>

            )}
            {((slug_2 == "api_docs" && slug_1 == "plans")) && (
                <Api_docs category="servers_orders" />
            )}
            {(slug_1 == "history") && (
                <History_home />
            )}
            {(slug_1 == "partner") && (
                <Post_content mode={'telegram'} show_adsense={'YES'} channel={'freefltiktok'} id_post={'117'} />
            )}
            {(slug_1 == "orders_once") && (
                <>
                    <Orders category_main={slug_2} />
                </>
            )}
            {/* {slug_1 === "partner" && (
                <Coin_partner_home />
            )}
            {slug_1 === "exchange" && (
                <Coin_exchange />
            )}
            {slug_1 === "seller" && (
                <Coin_seller_home />
            )} */}
        </>
    );
}

export default Coin_home;
